export function careersReadMore() {
    const items = document.querySelectorAll('.careers-list__item-right');

    items.forEach(item => {
        const content = item.querySelector('.careers-list__item-content');
        const readMoreBtn = item.querySelector('.read-more');

        content.style.maxHeight = '';
        readMoreBtn.style.display = 'none';

        const fullHeight = content.scrollHeight;

        if (fullHeight > 150) {

            content.style.maxHeight = '150px';
            content.style.overflow = 'hidden';
            content.classList.add('careers-list__item-content--hidden')

            readMoreBtn.style.display = 'inline-block';

            readMoreBtn.addEventListener('click', function() {
                if (content.style.maxHeight === '150px') {
                    content.style.maxHeight = fullHeight + 'px';
                    readMoreBtn.style.display = 'none';
                    content.classList.remove('careers-list__item-content--hidden')
                } else {
                    content.style.maxHeight = '150px';
                    readMoreBtn.innerText = 'Read More';
                }
            });
        }
    });
}